import { render, staticRenderFns } from "./FriendsBanner.vue?vue&type=template&id=41405d1e&scoped=true&"
import script from "./FriendsBanner.vue?vue&type=script&lang=js&"
export * from "./FriendsBanner.vue?vue&type=script&lang=js&"
import style0 from "./FriendsBanner.vue?vue&type=style&index=0&id=41405d1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41405d1e",
  null
  
)

export default component.exports